import React, { FC } from "react";
import { TableCell, TableRow, Typography } from "@mui/material";

import moment from "moment/moment";
import { capitalize } from "lodash";
import { Subscriber } from "./Subscribers.type";

type SubscribersRowProps = {
  data: Subscriber;
};

const SubscribersRow: FC<SubscribersRowProps> = ({ data }) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Typography variant="body2">{data.user_id}</Typography>
      </TableCell>
      <TableCell component="th" scope="row">
        <Typography variant="body2">
          {data.email || data.phone || "—"}
        </Typography>
      </TableCell>
      <TableCell component="th" scope="row">
        <Typography variant="body2">
          {data.registration_date
            ? moment.utc(data.registration_date).local().format("LLL")
            : "-"}
        </Typography>
      </TableCell>
      <TableCell component="th" scope="row">
        <Typography variant="body2">
          {moment.utc(data.subscription_created_at).local().format("LLL")} (
          {capitalize(data.subscription_period)})/(
          {data.subscription_store})
          {data.subscription_canceled_at ? "/(Canceled)" : ""}
        </Typography>
      </TableCell>
      <TableCell component="th" scope="row">
        <Typography variant="body2">
          {data.last_login
            ? moment.utc(data.last_login).local().format("LLL")
            : "-"}
        </Typography>
      </TableCell>
      <TableCell component="th" scope="row">
        <Typography variant="body2">
          {data.subscription_expired_at
            ? moment.utc(data.subscription_expired_at).local().format("LL")
            : "-"}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default SubscribersRow;
